export default __webpack_public_path__ + "static/media/D2Y.3b7c7812.png";